import React, { Component } from "react";
import { Tabs, Tab, Card, Table, Button, Form, Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import EyeImg from "../../../images/eye.png";
import gql from "graphql-tag";
import { withRouter } from "react-router-dom";
import compose from "lodash.flowright";
import { graphql } from "react-apollo";
import { Row, Col, Container } from "react-bootstrap";
import "./_pdf.scss";

/* ---------------- GRAPHQL QUERIES ---------------- */

const FETCH_PDF_FILES_DATA = gql`
  query GetAIMLFiles($exams: [String]) {
    getAIMLFiles(exams: $exams) {
      id
      file_name
    }
  }
`;

const FETCH_QUESTIONS = gql`
  query GetQuestions($id: Int!) {
    getAIMLFiles(id: $id) {
      questions {
        id
        question
        option1
        option2
        option3
        option4
        answer
        explanation
        subject
        chapter
        topic
      }
    }
  }
`;

class PdfTabs extends Component {

  state = {
    showModal: false,
    questions: [],
    questionPdf: null,
    solutionPdf: null,
    questionError: "",
    solutionError: "",
    page: 1,
    limit: 10,
    search: "",
    uploading: false,
    uploadMessage: "",
    uploadError: ""
  };

  /* ---------------- FILE CHANGE ---------------- */

  handleFileChange = (e, type) => {

    const file = e.target.files[0];
    if (!file) return;

    if (file.type !== "application/pdf") {
      this.setState({ [`${type}Error`]: "Only PDF files allowed" });
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      this.setState({ [`${type}Error`]: "File must be less than 5MB" });
      return;
    }

    this.setState({
      [type]: file,
      [`${type}Error`]: ""
    });

  };

  /* ---------------- FILE UPLOAD ---------------- */

  handleUpload = () => {

  const { questionPdf, solutionPdf } = this.state;

  let questionError = "";
  let solutionError = "";
  let valid = true;

  if (!questionPdf) {
    questionError = "Please upload Question PDF";
    valid = false;
  }

  if (!solutionPdf) {
    solutionError = "Please upload Solution PDF";
    valid = false;
  }

  this.setState({ questionError, solutionError });

  if (!valid) return;

  const formData = new FormData();

  // Files automatically sent as binary
  formData.append("questions_pdf", questionPdf);
  formData.append("solutions_pdf", solutionPdf);

  this.setState({
    uploading: true,
    uploadMessage: "",
    uploadError: ""
  });

  fetch("https://ai.rizee.in/autoext/docs", {
    method: "POST",
    body: formData
  })
    .then(res => res.json())
    .then((data) => {

      if (data.status === "success") {

        this.setState({
          uploading: false,
          uploadMessage: data.message || "PDF processed successfully!"
        });

        setTimeout(() => {

          this.setState({
            questionPdf: null,
            solutionPdf: null,
            uploadMessage: ""
          });

          if (this.questionInput) this.questionInput.value = "";
          if (this.solutionInput) this.solutionInput.value = "";

          // Refresh PDF list
          this.props.getPdfFiles.refetch({
            exams: ["JEE"]
          });

          // Switch to list tab
          document.querySelector('[data-rb-event-key="list"]').click();

        }, 3000);

      } else {

        this.setState({
          uploading: false,
          uploadError: data.message || "Processing failed."
        });

      }

    })
    .catch(err => {

      this.setState({
        uploading: false,
        uploadError: "Server error. Please try again."
      });

      console.error(err);

    });

};

  /* ---------------- FETCH QUESTIONS ---------------- */

  fetchQuestions = (id) => {

    this.props.getPdfs
      .refetch({ id: parseInt(id) })
      .then(res => {

        const questions = res.data.getAIMLFiles[0].questions || [];

        this.setState({
          showModal: true,
          questions
        });

      });

  };

  /* ---------------- PAGINATION ---------------- */

  handlePageChange = (page) => {

    if (page < 1) return;

    this.setState({ page });

    this.props.getPdfFiles.refetch({
      exams: ["JEE"],
      page,
      limit: this.state.limit
    });

  };

  /* ---------------- MODAL ---------------- */

  closePopup = () => {

    this.setState({
      showModal: false,
      questions: []
    });

  };

  decodeHTML = (text) => decodeURIComponent(text || "");

  renderHTML = (text) => ({
    __html: this.decodeHTML(text)
  });

  /* ---------------- RENDER ---------------- */


  handleSearch = (e) => {
    this.setState({
      search: e.target.value,
      page: 1
    });
  };

  nextPage = (totalPages) => {
    if (this.state.page < totalPages) {
      this.setState({ page: this.state.page + 1 });
    }
  };

  prevPage = () => {
    if (this.state.page > 1) {
      this.setState({ page: this.state.page - 1 });
    }
  };


  render() {

    const { loading, error, getAIMLFiles } = this.props.getPdfFiles;

    if (error) {
      alert("Server Error " + error.message);
      return null;
    }

    const pdfList = getAIMLFiles || [];

    const { page, limit, search } = this.state;

    const filteredList = pdfList.filter((pdf) =>
      pdf.file_name.toLowerCase().includes(search.toLowerCase())
    );

    const totalPages = Math.ceil(filteredList.length / limit);

    const paginatedList = filteredList.slice(
      (page - 1) * limit,
      page * limit
    );

    return (

      <section>

        <div style={{
          padding: "20px",
          background: "#f5f6fa",
          minHeight: "100vh"
        }}>

          <Card style={{
            borderRadius: "12px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.1)"
          }}>

              <Tabs
                defaultActiveKey="list"
                className="custom-pill-tabs mb-4 justify-content-center"
              >

              {/* ---------------- PDF LIST ---------------- */}

            <Tab
                eventKey="list"
                title={
                  <>
                    <i className="fas fa-file-pdf me-2"></i>
                    PDF LIST
                  </>
                }
              >

                {loading ? (

                  <Container>
                    <Row className="my-3">
                      <Col>
                        <div className="spinner-border text-primary"></div>
                      </Col>
                    </Row>
                  </Container>

                ) : (

                  <div style={{ padding: "20px" }}>

                     <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "15px" }}>

                      <Form.Control
                        type="text"
                        placeholder="Search PDF..."
                        style={{ width: "300px" }}
                        value={this.state.search}
                        onChange={this.handleSearch}
                      />

                    </div>

                    <Table bordered hover responsive className="table_custom_news">

                      <thead style={{ background: "#dee2e6" }}>
                        <tr>
                          <th>#</th>
                          <th>PDF Name</th>
                          <th>Action</th>
                        </tr>
                      </thead>

                      <tbody>

                        {paginatedList.map((pdf, index) => (

                          <tr key={pdf.id}>

                            <td>
                              {(this.state.page - 1) * this.state.limit + index + 1}
                            </td>

                            <td>{pdf.file_name}</td>

                            <td>

                              <img
                                  src={EyeImg}
                                  alt="view"
                                  width="40"
                                  height="40"
                                  style={{
                                    backgroundColor: "#e9f3ff",
                                    borderRadius: "50%",
                                    padding: "10px",
                                    cursor:"pointer",
                                    margin:"auto",
                                    display:"block"
                                  }}
                                  //onClick={() => this.fetchQuestions(pdf.id)}
                                  onClick={() => this.props.history.push(`/settings/PDFQuestions/${pdf.id}`)}
                                />

                            </td>

                          </tr>

                        ))}

                      </tbody>

                    </Table>
                    <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>

                      <Button
                        variant="secondary"
                        size="sm"
                        onClick={this.prevPage}
                        disabled={this.state.page === 1}
                      >
                        Prev
                      </Button>

                      <span style={{ margin: "0 15px", lineHeight: "30px" }}>
                        Page {this.state.page} / {totalPages || 1}
                      </span>

                      <Button
                        variant="secondary"
                        size="sm"
                        onClick={() => this.nextPage(totalPages)}
                        disabled={this.state.page === totalPages}
                      >
                        Next
                      </Button>

                    </div>

                  </div>

                )}

              </Tab>

              {/* ---------------- PDF UPLOAD ---------------- */}

              <Tab
                  eventKey="upload"
                  title={
                    <>
                      <i className="fas fa-cloud-upload-alt me-2"></i>
                      PDF UPLOAD
                    </>
                  }
                >

                <div className="upload-container">

                    <div className="row">

                      {/* Question PDF Card */}

                      <div className="col-md-6">
                        <Card className="upload-card">

                          <Card.Body className="text-center  p-2">

                            <i className="fas fa-file-pdf upload-icon"></i>

                            <h5 className="upload-title">Question PDF</h5>

                            <Form.Control
                              type="file"
                              accept="application/pdf"
                              ref={(ref) => (this.questionInput = ref)}
                              onChange={(e) => this.handleFileChange(e, "questionPdf")}
                            />

                            {this.state.questionError && (
                              <div className="upload-error">
                                {this.state.questionError}
                              </div>
                            )}

                          </Card.Body>

                        </Card>
                      </div>


                      {/* Solution PDF Card */}

                      <div className="col-md-6">
                        <Card className="upload-card">

                          <Card.Body className="text-center  p-2">

                            <i className="fas fa-book upload-icon"></i>

                            <h5 className="upload-title">Solution PDF</h5>

                            <Form.Control
                              type="file"
                              accept="application/pdf"
                              ref={(ref) => (this.solutionInput = ref)}
                              onChange={(e) => this.handleFileChange(e, "solutionPdf")}
                            />

                            {this.state.solutionError && (
                              <div className="upload-error">
                                {this.state.solutionError}
                              </div>
                            )}

                          </Card.Body>

                        </Card>
                      </div>

                    </div>


                    {/* Upload Button */}

                    {this.state.uploading && (
                      <div className="text-center mb-2">
                        <div className="spinner-border text-primary"></div>
                        <div>Uploading PDF...</div>
                      </div>
                    )}

                    {this.state.uploadMessage && (
                      <div className="alert alert-success text-center">
                        {this.state.uploadMessage}
                      </div>
                    )}

                    {this.state.uploadError && (
                      <div className="alert alert-danger text-center">
                        {this.state.uploadError}
                      </div>
                    )}

                    <div className="upload-btn-wrapper">

                     <Button
                          className="upload-main-btn"
                          onClick={this.handleUpload}
                          disabled={this.state.uploading}
                        >
                          {this.state.uploading ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2"></span>
                              Processing...
                            </>
                          ) : (
                            <>
                              <i className="fas fa-cloud-upload-alt me-2"></i>
                              Upload PDF
                            </>
                          )}
                        </Button>

                    </div>

                  </div>

              </Tab>

            </Tabs>

            {/* ---------------- QUESTIONS MODAL ---------------- */}

            

          </Card>

        </div>

        <Modal
            show={this.state.showModal}
            onHide={this.closePopup}
            size="lg"
            dialogClassName="pdf-analysis-modal"
          >

            <Modal.Header closeButton>
              <Modal.Title>Questions</Modal.Title>
            </Modal.Header>

            <Modal.Body
              style={{
                maxHeight: "70vh",
                overflowY: "auto"
              }}
            >

              {this.state.questions.length > 0 ? (

                this.state.questions.map((q, index) => (

                  <div
                    key={q.id}
                    style={{
                      border: "1px solid #ddd",
                      padding: "15px",
                      marginBottom: "20px",
                      borderRadius: "8px"
                    }}
                  >

                    {/* Subject Chapter Topic */}

                    <div style={{ marginBottom: "10px" }}>

                      <span className="badge bg-primary me-2">
                        Subject: <span dangerouslySetInnerHTML={this.renderHTML(q.subject)} />
                      </span>

                      <span className="badge bg-success me-2">
                        Chapter: <span dangerouslySetInnerHTML={this.renderHTML(q.chapter)} />
                      </span>

                      <span className="badge bg-warning text-dark">
                        Topic: <span dangerouslySetInnerHTML={this.renderHTML(q.topic)} />
                      </span>

                    </div>

                    {/* Question */}

                    <b style={{ color: "red" }}>
                      Q{index + 1}.
                    </b>

                    <div dangerouslySetInnerHTML={this.renderHTML(q.question)} />


                    {/* Options */}

                    <div className="row mt-2">

                      {q.option1 && (
                        <div className="col-md-6 mb-2 d-flex">
                          <strong className="me-2">A.</strong>
                          <div dangerouslySetInnerHTML={this.renderHTML(q.option1)} />
                        </div>
                      )}

                      {q.option2 && (
                        <div className="col-md-6 mb-2 d-flex">
                          <strong className="me-2">B.</strong>
                          <div dangerouslySetInnerHTML={this.renderHTML(q.option2)} />
                        </div>
                      )}

                      {q.option3 && (
                        <div className="col-md-6 mb-2 d-flex">
                          <strong className="me-2">C.</strong>
                          <div dangerouslySetInnerHTML={this.renderHTML(q.option3)} />
                        </div>
                      )}

                      {q.option4 && (
                        <div className="col-md-6 mb-2 d-flex">
                          <strong className="me-2">D.</strong>
                          <div dangerouslySetInnerHTML={this.renderHTML(q.option4)} />
                        </div>
                      )}

                    </div>

                    {/* Answer */}

                    <div
                      style={{
                        marginTop: "10px",
                        background: "#e8f5e9",
                        padding: "6px"
                      }}
                    >
                      <b>Answer:</b> {q.answer}
                    </div>

                    {/* Explanation */}

                    <div style={{ marginTop: "10px" }}>
                      <b>Explanation:</b>
                      <div dangerouslySetInnerHTML={this.renderHTML(q.explanation)} />
                    </div>

                  </div>

                ))

              ) : (

                <p>No Questions Available</p>

              )}

            </Modal.Body>

            {/* Modal Footer */}

            <Modal.Footer>

              <Button
                variant="secondary"
                onClick={this.closePopup}
              >
                Close
              </Button>

            </Modal.Footer>

          </Modal>

      </section>

    );

  }

}

export default compose(

  withRouter,

  graphql(FETCH_PDF_FILES_DATA, {
    options: () => ({
      variables: {
        exams: ["JEE"]
      }
    }),
    name: "getPdfFiles"
  }),

  graphql(FETCH_QUESTIONS, {
    options: () => ({
      variables: {
        id: 0
      }
    }),
    name: "getPdfs"
  })

)(PdfTabs);